import React from 'react';
import CaseDetail_Comp from '../../Components/CaseDetail/CaseDetail';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function CaseDetail() {
  return (
    <>
    <Dashboard_Comp>
    <CaseDetail_Comp />
    </Dashboard_Comp>
    </>
  )
}

export default CaseDetail;